import { render, staticRenderFns } from "./BiChart.vue?vue&type=template&id=e158312c&"
import script from "./BiChart.vue?vue&type=script&lang=js&"
export * from "./BiChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e158312c')) {
      api.createRecord('e158312c', component.options)
    } else {
      api.reload('e158312c', component.options)
    }
    module.hot.accept("./BiChart.vue?vue&type=template&id=e158312c&", function () {
      api.rerender('e158312c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components-globalwork/BiChart.vue"
export default component.exports